<template>
    <div>

      <!-- Card -->
      <b-card class="post-list">
  
        <!-- Card header -->
        <template #header>
          <div class="row align-items-center">
            <div class="col-xs" style="padding: 1.0416vw;">
              <h3>Post List</h3>
            </div>
            <!-- Refresh Button(검색조건 있을때만 보이게)-->
            <div class="col" style="display: flex; justify-content: flex-end;">
              <div class="btn-wrap">
                <div class="btn-group-area align-items-center">
                  <!-- Excel Button
                  <b-button variant="outline-secondary" @click="pushRoute('/chatter/import')" class="btn btn-export">Excel
                  </b-button>
                  -->
                  <!-- <b-button v-b-modal.export variant="outline-secondary" class="btn btn-export">Export
                  </b-button> -->
                </div>
                <b-button variant="outline-success"
                          class="btn btn-primary small"
                          @click="pushRoute('/chatter/post-detail')">Create
                </b-button>
              </div>
            </div>
          </div>
        </template>
        <!-- /Card header -->
  
        <!-- Card body -->
        <template #default>
          <div style="position:relative">
  
            <!-- Spinner -->
            <loading :active="loading" :is-full-page="false" />
            <!-- /Spinner -->
  
            <!-- Filter -->
            <!-- TODO 필터 컴포넌트 구현 -->
            <board-filter @click:searchButton="search"/>
            <!-- <chatter-filter @reload="reloadChatterList" :isRefreshed="refresh" /> -->
            <!-- /Filter -->

            <div class="sort-area">
              <span class="total-result">검색결과 {{ total }}개</span>

              <!-- <div style="display:inline-block; position:relative;">
                <b-icon :icon="sortIcon" style="position:absolute; top:50%; transform:translateY(-50%); left:5%; font-size: 1.1rem;"></b-icon>
                <select class="sort-select-box" v-model="sortOptions" @change="getPosts">
                  <option value="desc">최신 순</option>
                  <option value="asc">오래된 순</option>
                </select>
              </div> -->
              
            </div>
  
            <!-- Table -->
            <div class="custom-table-container">
              <table class="table table-hover custom-table" ref="postTable">
                <colgroup>
                  <col v-for="column in tableColumns" :key="column.name" :width="column.width" />
                </colgroup>
  
                <thead>
                  <tr class="text-center table-dark">
                    <th v-for="column in tableColumns" :key="column.name" @click="sort(column.name)" class="chat-list-header">
                      {{ column.name | formatColumnName }}
                      <b-icon-triangle-fill v-if="column.sort === 'ASC'" font-scale="0.75" />
                      <b-icon-triangle-fill flip-v v-else-if="column.sort === 'DESC'" font-scale="0.75" />
                    </th>
                  </tr>
                </thead>
  
                <tbody v-if="posts.length !== 0">
                  <template v-for="post in posts">
                    <tr :key="post.id" v-if="post.status == 'ACTIVE'" @click="showPostDetail(post.id)" style="cursor: pointer;">
                      <!-- Post ID -->
                      <td class="text-center align-middle">
                        {{ post.id }}
                      </td>
                      <!-- /Post ID -->
    
                      <!-- Post Title -->
                      <td class="align-middle" :style="{paddingLeft : getPadding(post.depth)}">
                        <b-icon v-if="post.depth != 0" icon='arrow-return-right' class="mr-1"></b-icon>
                        
                        <span class="post-title" :class="getTitleClassByMatched(post.matched)">{{ post.title }}</span>
                      </td>
                      <!-- /Post Title -->
    
    
                      <!-- Creator -->
                      <td class="text-center align-middle">
                        <user-profile :id=post.creator.id :name="post.creator.name" :post="post.creator.profileImage" />
                      </td>
  
                      <td class="text-center align-middle">
                        {{ post.creationDate }}
                      </td>
  
                      <td class="text-center align-middle">
                        <user-profile v-if="post.updater.id" :id=post.updater.id :name="post.updater.name" :post="post.updater.profileImage" />
                      </td>
                      <!-- /Priority -->
    
                      <td class="text-center align-middle">
                        {{ post.updatedDate }}
                      </td>
                    </tr>
                    <tr v-else class="deleted">
                      <td class="text-center align-middle">
                        {{ post.id }}
                      </td>

                      <td class="align-middle post-title" :style="{paddingLeft : getPadding(post.depth)}" colspan="5">
                       <b-icon v-if="post.depth != 0" icon='arrow-return-right' class="mr-1"></b-icon>
                       <span>삭제된 게시글 입니다.</span>
                      </td>
                    </tr>
                  </template>
                </tbody>
  
                <tbody v-else>
                  <tr>
                    <td colspan="11" style="text-align:center">결과가 없습니다.
                    </td>
                  </tr>
                </tbody>
  
              </table>
            </div>
            <!-- Table -->
          </div>
          <div style="width:100%; display:flex; justify-content:center">
            <pagination style="width:60%" 
              :total="total" 
              :currentPageNo="currentPageNo" 
              :pageSize="pageSize" 
              @update:currentPageNo="updateCurrentPageNoHandler"
            />
          </div>
        </template>
        <!-- Card body -->
      </b-card>
    </div>
  </template>
  <script>
  import Loading from 'vue-loading-overlay';
  
  import UserProfile from './UserProfile.vue';
  import Pagination from "./Pagination.vue";
  import BoardFilter from "./BoardFilter.vue";
  
  import RefreshIcon from "@/components/chatter/icons/RefreshIcon.vue";
  import SubordinateToArrowIcon from "@/components/chatter/icons/SubordinateToArrowIcon.vue";
  import SuperiorToArrowIcon from "@/components/chatter/icons/SuperiorToArrowIcon.vue";
  import SubordinateToIcon from "@/components/chatter/icons/SubordinateToIcon.vue";
  import SuperiorToIcon from "@/components/chatter/icons/SuperiorToIcon.vue";
  import SeeMoreIcon from "@/components/chatter/icons/SeeMoreIcon.vue";
  import postResponse from "@/components/board/models/posts.json";
  
  export default {
    name: "PostList",
    components: {
      Loading,
      UserProfile,
      Pagination,
      BoardFilter,
      RefreshIcon,
      SubordinateToArrowIcon,
      SuperiorToArrowIcon,
      SuperiorToIcon,
      SubordinateToIcon,
      SeeMoreIcon
    },
    computed: {
      conditions() {
        return this.$store.getters['board/conditions'];
      },
      pageSize() {
        return this.$store.getters['board/pageSize'];
      },
      currentPageNo() {
        return this.$store.getters['board/currentPageNo'];
      },
      tableColumns() {
        return this.$store.getters['board/tableColumns'];
      },
      sortOptions() {
        return this.$store.getters['board/sort'];
      },
      hasHierarchySearched() {
        return this.$store.getters['board/hasHierarchySearched'];
      }
    },
    data() {
      return {
        loading: false,
        posts : [],
        total : 0,
      }
    },
    mounted() {
      this.getPosts();
    }, 
    methods: {
      getPosts() { 
        // TODO API 호출
        try {
          this.loading = true;

          const scope = this.conditions.scope;
          let scopeArray = [];
          // scope 전처리
          if(scope) {
            scopeArray = scope.split('/');
          }
          const params = {
            keyword: this.conditions.keyword,
            scope: scopeArray,
            sort: this.sortOptions,
            hierarchy: this.conditions.hierarchy,
            pageSize: this.pageSize,
            pageNo: this.currentPageNo
          };

          axios.post('/board/retrievePostList', params,{
              headers: {
                Authorization: accessToken(),
                "Content-Type": 'application/json'
              }
            }
          ).then(response => {
            // TODO 논리 코드 식별 로직 추가
            const status = response.data.status;
            if(status === '200') {
              this.posts = response.data.body.posts;
              this.total = response.data.body.total;
              this.$store.commit('board/setPageNo', response.data.body.pageNo);
            }
          });
        } catch(e) {
          console.log(e);    
          this.loading = false;
        } finally {
          this.loading = false;
        }
        // this.posts = postResponse.posts;
        // this.$store.commit('board/setPageNo', postResponse.pageNo);
        // this.$store.commit('board/setTotal', postResponse.total);
      },
      updateCurrentPageNoHandler(pageNo) {
        // 현재 페이지 변경
        this.$store.commit('board/setPageNo', pageNo);
        this.getPosts();

        // 스크롤을 테이블의 시작부분으로 이동
        this.scrollToList();
      },
      scrollToList() {
        // 테이블 요소 가져오기
        const postTable = this.$refs['postTable'];

        if(postTable) {
          // 테이블의 스크롤 오프셋 가져오기
          const offsetTop = postTable.offsetTop;
          
          // 현재 브라우져의 스크롤 정보를 테이블 스크롤 오프셋으로 초기화
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });
        }
      },
      showPostDetail(id) {
        this.pushRoute('/chatter/post-detail/' + id);
        // TODO 게시글 상세 조회 이동
        // this.$router.push({ name: "chatUpdate", params: { id: chatId } });
      },
     
      getPadding(depth) {
        const padding = depth * 1.5;
        return padding + 'em';
      },
      sort(fieldName) {
        // Commit sorting orders
        this.$store.commit('board/setSort', fieldName);
        if(this.sortOptions.length > 0 && this.conditions.hierarchy) { // 정렬값이 없고 conditions.hierarchy가 true이면 false로 초기화
          this.conditions.hierarchy = false;
          this.$store.commit('board/setHasHierarchySearched')
        }
        this.getPosts();
      },
      initPagination() {
        this.$store.commit('board/setPageNo', 1);
      },
      search() {
        if(this.conditions.hierarchy) {
          this.$store.commit('board/setHasHierarchySearched', true);
        } else {
          this.$store.commit('board/setHasHierarchySearched', false);
        }
        // 검색 버튼 클릭 시 페이지 초기화
        this.initPagination();
        this.getPosts();
      },
      getTitleClassByMatched(isMatched) {
        if(!this.hasHierarchySearched) return {}
        else {
         return {
          'matched': isMatched,
          'unmatched': !isMatched
         }
        }

      }
    },
    filters: {
     
      formatColumnName(name) {
        // 첫 글자를 대문자로 변경하고 중간에 대문자가 있는 경우 띄어쓰기 추가
        if (name.toUpperCase() === "ID") {
          // Exception. Id의 경우 모두 대문자로 변환하여 사용 - 20230614 박선익
          return name.toUpperCase()
        }
        return name.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
          return str.toUpperCase();
        });
      },
    },
  }
  </script>
  <style scoped> 
  /* import font */
  @import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');

  td {
    vertical-align: middle;
  }
  
  .down-arrow-icon {
    transform: translate(-50%, -50%) rotate(180deg);
    margin-left: 1em;
  }
  
  .chat-list-header {
    user-select: none;
    /* 드래그 불가능 */
    cursor: pointer;
    /* 포커스 시 커서를 손가락 모양으로 설정 */
  }
  
  .tooltip .tooltip-inner {
    max-width: 1000px !important;
    white-space: pre-wrap !important;
    text-align: start;
  }
  
  .popover {
    max-width: 1000px !important;
  }

  
  /* button */
  .btn {
    border-radius: 10px;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
  }
  
  .btn:focus {
    box-shadow: none;
  }
  
  .btn-primary {
    width: 280px;
    height: 60px;
    background-color: #2E2E38;
    color: #FFE600;
    border-color: transparent;
  }
  
  .btn-primary:hover {
    color: #FFE600;
    background-color: #0D0D17;
    border-color: transparent;
  }
  
  .btn-primary.disabled,
  .btn-primary:disabled {
    color: #9C9CA8;
    background-color: #C4C4CD;
    border-color: transparent;
  }
  
  .btn-primary.small {
    width: 148px;
    height: 40px;
  }
  
  .btn-export {
    width: 100px;
    height: 40px;
    background-color: #168D4C;
    color: #fff;
    border-color: transparent;
  }
  
  .btn-export:hover {
    background-color: #006F2E;
    border-color: transparent;
  }
  
  .btn-export.disabled,
  .btn-export:disabled {
    color: #62796D;
    background-color: #759483;
  }
  
  .btn.btn-line {
    position: relative;
    width: 135px;
    height: 60px;
    border: 1px solid #C4C4CD;
    background-color: transparent;
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
    text-align: inherit;
  }
  
  .btn.btn-line:hover {
    color: #2E2E38;
    border: 1px solid #2E2E38;
    background-color: transparent;
  }
  
  .btn.btn-line.disabled,
  .btn.btn-line:disabled {
    border: 1px solid #DDDDE3;
    background-color: transparent;
  }
  
  .btn.btn-line.small {
    height: 40px;
    text-align: center;
  }
  
  .btn-refresh {
    height: auto;
    padding: 0;
  }
  
  /* 공통요소 */
  .select-custom-scrollbar::-webkit-scrollbar {
    width: 12px;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid transparent;
    background-clip: padding-box;
  }
  
  .select-custom-scrollbar::-webkit-scrollbar-track {
    width: 6px;
    background-color: #E7E7EE;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid transparent;
    background-clip: padding-box;
  }
  
  .select-custom-scrollbar::-webkit-scrollbar-thumb {
    width: 100%;
    background-color: #C4C4CD;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid transparent;
    background-clip: padding-box;
  }
  
  /* card 영역 */
  .card {
    margin-bottom: 2rem;
    border-radius: 30px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
    font-family: 'NanumGothic';
  }
  
  .card>.card-body {
    padding-top: max(2rem, 1.5625vw);
    padding-left: 2.0833vw;
    padding-right: 2.0833vw;
    /* padding-bottom: max(2.666rem, 2.0833vw); */
  }
  /* chatter list 영역 */
  .card.post-list {
    margin-bottom: 2rem;
    border-radius: 30px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
  }
  
  .card.post-list .card-header {
    padding-top: max(2rem, 1.5625vw);
    padding-left: 2.0833vw;
    padding-right: 2.0833vw;
    padding-bottom: 1erm;
    border-radius: 30px 30px 0 0;
    border-bottom: none;
  }
  
  .card.post-list .card-header>div {
    flex-wrap: wrap;
    /* gap: 2rem; */
  }
  
  .card.post-list .card-header .title-wrap {
    display: flex;
    gap: 0 1.333rem;
  }
  
  .card.post-list .card-header h3 {
    display: flex;
    align-items: center;
    gap: 0 1.333rem;
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 24px;
    font-weight: 700;
    line-height: 150%;
  }
  
  .card.post-list .card-header h3>span {
    white-space: nowrap;
  }
  
  .card.post-list .card-header .btn-wrap {
    display: flex;
    gap: 0 2rem;
  }
  
  .card.post-list .card-header .btn-wrap .btn-group-area {
    position: relative;
    display: flex;
    gap: 0 0.666rem;
  }
  
  .card.post-list .card-header .btn-wrap .btn-group-area::after {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    right: -1rem;
    transform: translateY(-50%);
    width: 1px;
    height: calc(100% - 1.066rem);
    background-color: #DDDDE3;
  }
  
  /* my chatter list table 영역 */
  .custom-table-container {
    margin-top: 1rem;
    padding: 0.666rem;
    border-radius: 20px;
    background-color: #F6F6FA;
  }
  
  .table.custom-table {
    margin-bottom: 0;
  }
  
  .table.custom-table tr {
    color: #2E2E38;
    background-color: #FFF;
  }
  
  .table.custom-table tr:hover {
    background-color: #FAFAFA;
  }

  .table.custom-table tr.deleted:hover {
    background-color: #fff
  }
  
  .table.custom-table thead th,
  .table-bordered.custom-table th {
    height: 70px;
    padding-top: calc(0.75rem - 0.666rem);
    background-color: #F6F6FA;
    border-top: none;
    border-left: none;
    border-right: none;
    border-bottom: 1px solid #C4C4CD;
    text-align: center;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 700;
    line-height: 150%;
    vertical-align: middle;
    white-space: nowrap;
  }
  
  .table.custom-table td {
    height: 90px;
    padding: 1.333rem 0.666vw;
    border-top: 1px solid #E7E7EE;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
    vertical-align: middle;
  }
  
  .table.custom-table td .title-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .table.custom-table td .title-wrap .title-container {
    flex-grow: 1;
  }
  
  .table.custom-table td .title-wrap .title-text {
    padding-left: 2.067rem;
    font-weight: 700 !important;
  }
  
  .table.custom-table td .title-wrap .chatter-hierarchy {
    display: flex;
    align-items: center;
    gap: 0 0.533rem;
    padding-left: 0.533rem;
    color: #747480;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
  }


  .table.custom-table tr:last-child td:first-child {
    border-radius: 0 0 0 10px;
  }
  
  .table.custom-table tr:last-child td:last-child {
    border-radius: 0 0 10px 0;
  }
  
  .table.custom-table .status-tag {
    display: inline-block;
    max-width: 100px;
    width: 100%;
    height: 29px;
    padding: 4px 6px;
    border-radius: 38px;
    text-align: center;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
    white-space: nowrap
  }
  
  .table.custom-table .status-tag.in-progress {
    background-color: #F5ECD6;
    color: #FF5C00;
  }
  
  .table.custom-table .overdue .status-tag.in-progress {
    background-color: #F5D6D6;
    color: #F00;
  }
  
  .table.custom-table .status-tag.to-do {
    background-color: #F6F6FA;
    color: #2E2E38;
  }
  
  .table.custom-table .status-tag.done {
    background-color: #CFDDFF;
    color: #1755CC;
  }
  
  .table.custom-table .status-tag.closed {
    background-color: #D7F5D6;
    color: #168D4C;
  }
  
  .table.custom-table .status-tag.cancelled {
    background-color: #E4E4EA;
    color: rgba(116, 116, 128, 0.70);
  }
  
  .btn.updated {
    padding: 0;
    background-color: transparent;
    border-radius: 0;
    color: #1755CC;
    font-size: 12px;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
    opacity: 1;
  }
  
  .level-circle {
    display: inline-block;
    font-size: 6px;
    margin-left: 0.533rem;
    transform: translateY(-1.5px);
  }
  
  .unread-label {
    position: relative;
    top: unset;
    left: unset;
    transform: none;
    color: #F00;
    font-size: 12px;
    font-weight: 400;
    line-height: normal;
    white-space: nowrap;
    opacity: 1;
  }
  
  .assignee-wrap {
    display: flex;
    align-items: center;
    gap: 0 0.729vw;
    width: 100%;
    white-space: nowrap;
  }
  
  .assignee-wrap .user-profile {
    position: relative;
    flex-grow: 1;
    flex-shrink: 0;
    display: inline-block;
    width: 40px;
    height: 40px;
    overflow: hidden;
    border-radius: 50%;
  }
  
  .assignee-wrap .user-profile img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    object-fit: cover;
  }
  
  .assignee-wrap .user-today-off-img {
    position: absolute;
    width: 18px;
    height: 15px;
    transform: translate(165%, -120%);
  }
  
  .assignee-wrap .assignee-name {
    width: calc(100% - 40px - 0.729vw);
    max-width: 98px;
  }
  
  .assignee-wrap .assignee-day-off {
    font-size: 10px;
  }
  
  .btn-more-area {
    display: flex;
    justify-content: center;
    margin-top: 2.666rem;
  }
  
  .btn-more-area .btn-view-more {
    display: inline-block;
    width: auto;
    height: auto;
    margin: 0;
    padding: 1.3rem 3.3rem 1.3rem 3.033rem;
    border-radius: 60px;
    background-color: #E7E7EE;
  }
  
  .btn-more-area .btn-view-more .icon {
    margin-top: -3px;
    margin-right: 0.533rem;
  }
  
  .btn-more-area .btn-view-more span {
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 14px;
    line-height: 150%;
  }
  
  .btn-more-area .btn-view-more:hover {
    background-color: #C4C4CD;
  }
  
  /* .btn-reset-img{
    width:25px;
    height:27px;
    margin: 0 10px 0 10px;
  
  }
  .btn-recent-img{
    width:30px;
    height:30px;
  } */
  
  .recent-button {
    display: flex;
    align-items: center;
    gap: 0 12px;
    padding: 8px 12px 8px 16px;
    border-radius: 40px;
    border: none;
    background-color: #E7E7EE;
    color:#2E2E38;
    font-family: 'NanumGothic';
    font-size: 16px;
    font-weight: 500;
    line-height: 150%;
  }
  
  .recent-button:hover {
    background-color: #DDDDE3;
  }
  
  .recent-button .icon {
    display: block;
    width: 24px;
    height: 24px;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M3 17H10" stroke="%232E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M3 12H14" stroke="%232E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M3 7H14" stroke="%232E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M15 16L13 18L15 20" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.5556 14H18.7778C20.0051 14 21 14.8954 21 16C21 17.1046 20.0051 18 18.7778 18H14" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
    background-repeat: no-repeat;
  }
  
  .refresh-button {
    display: flex;
    align-items: center;
    gap: 0 12px;
    padding: 8px 12px 8px 16px;
    border-radius: 40px;
    border: none;
    background-color: #2E2E38;
    color:#FFF;
    font-family: 'NanumGothic';
    font-size: 16px;
    font-weight: 500;
    line-height: 150%;
  }
  
  .refresh-button .icon {
    display: block;
    width: 18px;
    height: 18px;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M13.5 13.5L4.5 4.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.5 4.5L4.5 13.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
    background-repeat: no-repeat;
  }

  /** 정렬 영역 **/
  .sort-area {
    margin-top: 0.6rem;
  }
  .sort-area .total-result {
    color : rgb(160, 160, 160);
    padding: 0 1rem;
    font-size: 1.1rem;
  }

  .sort-area .sort-select-box {
    appearance: none;
    padding: 5px 7px 5px 20px;
    font-size: 16px;
    border:none;
    border-radius: 5px;
    background-color: #fff;
    color: #333;
    text-align: center;
  }

  .post-list .post-title.matched {
    font-weight: bold;
  }
  .post-list .post-title.unmatched {
    color: grey;
  }
  </style>;